import SubjectColumn from "./SubjectColumn";

export const columns = [
    {
        label: "Journal",
        field: "journalName",
    },
    {
        label: "Subject(s)",
        field: "subject",
        format: SubjectColumn.format
    },
];
